// /blog URLs are served pre-rendered by the backend (backend/app/api/endpoints/
// prerender.py) so crawlers and link previews get the real article. The page
// arrives with extra <head> tags marked data-prerender and a #prerender block
// above #root.

/** Drop the pre-rendered <head> tags so the per-route <SEO> tags are the only ones. */
export const removePrerenderedHeadTags = (): void => {
  document.querySelectorAll('[data-prerender]').forEach(node => node.remove());
};

/** Remove the pre-rendered page once the real page can render its own content. */
export const removePrerenderedPage = (): void => {
  document.getElementById('prerender')?.remove();
};
